// @ts-nocheck — legacy auth saga registrations; will be replaced in Phase 1 with LeadNova auth
import { takeLatest, all } from "redux-saga/effects";
import { SAGA_ACTIONS } from "../_config";

import {
  forgotPassword,
  getUserProfile,
  loginUser,
  logoutUser,
  resetPassword,
  registration,
  updateUserProfile,
} from "./userSaga";

export function* sagas() {
  yield all([
    takeLatest(SAGA_ACTIONS.AUTH.DETAILS, getUserProfile),
    takeLatest(SAGA_ACTIONS.AUTH.LOGIN, loginUser),
    takeLatest(SAGA_ACTIONS.AUTH.FORGOT_PASSWORD, forgotPassword),
    takeLatest(SAGA_ACTIONS.AUTH.RESET_PASSWORD, resetPassword),
    takeLatest(SAGA_ACTIONS.AUTH.REGISTRATION, registration),
    takeLatest(SAGA_ACTIONS.AUTH.UPDATE_PROFILE, updateUserProfile),
    takeLatest(SAGA_ACTIONS.AUTH.LOGOUT, logoutUser),
  ]);
}
